import { UserNetworkStatus } from '~Data';

export const networkStatusChoices: Record<UserNetworkStatus, string> = {
  [UserNetworkStatus.Incomplete]: 'New (Incomplete)',
  [UserNetworkStatus.NoNetwork]: 'No Network',
  [UserNetworkStatus.NotNowNetwork]: 'Not Now Network',
  [UserNetworkStatus.PendingReview]: 'New (Pending Review)',
  [UserNetworkStatus.YesNetwork]: 'Yes Network',
};
